import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { ReactComponent as Print } from '../../../assets/icons/print.svg';
import { ReactComponent as Done } from '../../../assets/icons/Logout.svg';
import actions from '../../../actions';
import Card from '../../components/DigitalCard';
import DialogBox from '../../components/DialogBox';
// import HOC from '../../hoc/sessionTimeout';
import * as Constant from '../../../constants/actionTypes';
import { firstLowerLetter, labelName } from '../../UtilsWeb';
import styles from './styles';

class ProviderCard extends PureComponent {
  static propTypes = {
    location: PropTypes.object.isRequired,
    locale: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
  };

  state = {
    isOpen: false,
  };

  componentDidMount = () => {
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener(Constant.POP_STATE, () => {
      // eslint-disable-next-line react/prop-types
      const { actions: actionCall } = this.props;
      actionCall.reset();
    });
  };

  componentWillUnmount = () => {
    window.removeEventListener(Constant.POP_STATE, {});
  };

  toggle = confirm => {
    const { isOpen } = this.state;
    // eslint-disable-next-line react/prop-types
    const { history, actions: actionCall } = this.props;

    this.setState({ isOpen: !isOpen });

    if (confirm === Constant.TRUE) {
      actionCall.reset();
      history.push(`${Constant.SLASH}${firstLowerLetter(Constant.PROVIDER_LOGIN_LINK)}`);
    }
  };

  goBack = () => {
    this.setState({
      isOpen: true,
    });
  };

  render() {
    const { isOpen } = this.state;
    const { locale, classes, location, intl } = this.props;
    const { state } = { ...location };
    const { data } = { ...state };
    const { data: stateData, watermark } = { ...data };
    const { Attribute1, Attribute2, Attribute3 } = { ...watermark };
    const {
      Member: { FirstName },
    } = { ...stateData[0] };
    return (
      <div className="bodyContainerWrapper" role="main" id="provider-card-template">
        <Paper className={`pageContentWrapper ${classes.paperStyle}`}>
          <h1 className="pageHeader">
            {`${intl
              .formatMessage({ id: Constant.LABEL_DIGITAL_CARD_DIG_CARD_MEMBER })
              .replace(Constant.FIRST_NAME, `${FirstName}`)}`}
          </h1>
          <Card locale={locale} groupMember={stateData[0]} />
          <div className="waterMark">
            {!!Attribute3 && (
              <span>
                {labelName(Constant.LABEL_PROVIDER_DATE)} {`${Attribute3}  `}
              </span>
            )}
            {!!Attribute2 && (
              <span>
                {labelName(Constant.LABEL_PROVIDER_IP)} {`${Attribute2}  `}
                <br />
              </span>
            )}
            {!!Attribute1 && (
              <span>
                {labelName(Constant.LABEL_PROVIDER_EMAIL)} {`${Attribute1}`}
              </span>
            )}
          </div>
          <div className="buttonWrapper" style={{ justifyContent: 'space-between' }}>
            <Button
              label="Go Back"
              color="primary"
              className={classes.button}
              onClick={this.goBack}
            >
              <Done className={classes.leftIcon} />
              {labelName(Constant.LABEL_CLOSE_APP)}
            </Button>
            <Button
              label="Print"
              color="primary"
              className={classes.button}
              onClick={() => window.print()}
            >
              <Print className={classes.leftIcon} />
              {labelName(Constant.LABEL_PRINT)}
            </Button>
          </div>

          {isOpen && (
            <DialogBox
              open={isOpen}
              locale={locale}
              toggle={this.toggle}
              dialogTitle={labelName(Constant.LABEL_POPUP_HEADER1)}
              dialogContentText={labelName(Constant.LABEL_POPUP_HEADER2)}
            />
          )}
        </Paper>
      </div>
    );
  }
}

ProviderCard.propTypes = {
  locale: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  // onPrint: PropTypes.func.isRequired,
};
const mapStateToProps = state => ({
  locale: state.locale.locale,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
});
const x = injectIntl(ProviderCard);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(x)); // HOC(x)
